

function activateFAQs() {

    var faqs = document.querySelector('.faqs');

    if (typeof(faqs) != 'undefined' && faqs !=  null) {

        var acc = document.getElementsByClassName('accordion-title');

        for (var i = 0; i < acc.length; i++) {
            acc[i].addEventListener('click', function(e) {
                e.preventDefault();
                this.parentNode.classList.toggle('is-active');
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                } else {
                panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            });
        }

    }
}
export default function init() {
    activateFAQs();
}
